import { TitleOfferFragment } from '@/features/buybox/graphql/fragments/Offer.fragment';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { FALLBACK_PROMOTION_OFFER } from '@/helpers/promotion-helper';
import { useExperiment } from '@/libraries/experiment';
import { MaybeRefOrGetter, toValue } from '@vueuse/core';
import { computed } from 'vue';

const overProviderCountries = ['IT', 'FR'];

/**
 * This experiment had a successful run, so we are moving to full implementation in one country (FR) to begin with. More countries will follow.
 * Not tag updates needed, just a pure revenue analysis.
 * I would keep this composable here, and the related component, until it looks like a complete implementation is ready.
 */

export function useOverProviderExp({
	promotionOffer,
}: {
	promotionOffer: MaybeRefOrGetter<TitleOfferFragment | null>;
}) {
	const { country } = useLanguageStore();

	const { activeVariantWithControlGroup: doubleStackExpVariant } = useExperiment('DOUBLE_STACK_EXP_3');
	const isOverProviderCountry = computed(() => overProviderCountries.includes(country.value));

	const _promotionOffer = computed(() => toValue(promotionOffer));

	const isOverProviderTitle = computed(() => {
		if (!isOverProviderCountry.value) return false;
		if (!_promotionOffer.value) return false;

		// Double Stack Exp
		if (!!doubleStackExpVariant.value) return false;
		// Double Stack Exp

		return _promotionOffer.value.id !== FALLBACK_PROMOTION_OFFER;
	});

	return {
		isOverProviderTitle,
	};
}
